{
  "home": "Асосӣ",
  "games": "Бозиҳо",
  "casino": "Казино",
  "sports": "Варзиш",
  "bonuses": "Бонусҳо",
  "wallet": "Касса",
  "menu": "Меню",
  "profile": "Кабинет",
  "login": "Вуруд",
  "loginSoon": "Вуруд — ба зудӣ"
}